module.exports = __webpack_public_path__ + "media/cases-brand-hpnk-lazyload-71.1a8f7dd5.mp4";